import React, { useState, useEffect, useCallback } from "react";

import { useNavigate } from "react-router-dom";

import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { CircularProgress } from "@mui/material";

import { axiosInstance } from "../service/axiosInstance";

import { formatDate } from "../utils/utils";
import serviceEndpoints from "../services/serviceEndpoints";

const RegularizeAttendanceListComponent = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const [regularisationDates, setRegularisationDates] = useState([]);

  const handleNavigation = (date) => {
    navigate("/regularize-meeting-menu", { state: date });
  };

  const getRegularisationDates = useCallback(async () => {
    setLoader(true);
    try {
      let res = await axiosInstance.get(
        serviceEndpoints.getRegularisationDatesEndpoint
      );
      setRegularisationDates(res.data.regularisationDates);
    } catch (err) {
      console.log(err);
    } finally {
      setLoader(false);
    }
  }, []);

  useEffect(() => {
    getRegularisationDates();
  }, [getRegularisationDates]);

  return (
    <>
      {loader ? (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          }}
        >
          <CircularProgress size={60} sx={{ color: "var(--aqua-1)" }} />
        </Box>
      ) : (
        <>
          {regularisationDates && regularisationDates.length === 0 ? (
            <Container
              sx={{
                marginTop: 4,
              }}
            >
              <Alert
                variant="outlined"
                severity="warning"
                className="alert-message"
              >
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    fontSize: "16px",
                  }}
                  className="typography_heading"
                >
                  No regularisation dates available!
                </Typography>
              </Alert>
            </Container>
          ) : (
            <>
              {" "}
              {regularisationDates.map((item, index) => (
                <Container
                  sx={{
                    marginTop: 2,
                    marginBottom: index === regularisationDates.length - 1 && 4,
                    paddingBottom:
                      index === regularisationDates.length - 1 && "80px",
                  }}
                  key={index}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "30px",
                      padding: "10px",
                      paddingLeft: "20px",
                      // border: "2px solid #ddd",
                      flexDirection: "row",
                      textAlign: "left",
                      cursor: "pointer",
                      margin: "auto",
                    }}
                    className="container_bg"
                    onClick={() => handleNavigation(item.regularisationDate)}
                  >
                    <Box>
                      <Typography
                        variant="h6"
                        className="typography_heading head-list"
                      >
                        {formatDate(item.regularisationDate)}
                      </Typography>
                      <Typography
                        variant="body1"
                        className="regularisation_date_body"
                      >
                        Short by {item.regularisationCount}{" "}
                        {item.regularisationCount > 1 ? "meetings" : "meeting"}
                      </Typography>
                    </Box>
                    <ChevronRightIcon
                      sx={{
                        marginLeft: "auto",
                        fontSize: "45px !important",
                        // color: "#FF0000 !important",
                      }}
                      className="icons "
                    />
                  </Box>
                </Container>
              ))}
            </>
          )}
        </>
      )}
    </>
  );
};

export default RegularizeAttendanceListComponent;
